import i18n from '@baidu/bce-i18n';
import {isConsoleOnline} from './constants';

export const getBrowserLanguage = () => {
    let language = 'zh-cn';
    if (navigator.language || (navigator as any).userLanguage) {
        language = navigator.language || (navigator as any).userLanguage;
    }
    if (navigator.languages && navigator.languages[0]) {
        language = navigator.languages[0];
    }
    return language.toLowerCase();
};

export const getLanguage = () => {
    const language = window?.framework?.i18n?.getCurrentLanguage?.();
    if (language) {
        return language;
    }
    const queryLocale = /locale=([a-zA-Z-]+)/g.exec(location.search);
    return queryLocale?.[1] || getBrowserLanguage();
};

export const initI18n = async () => {
    const language = getLanguage();
    const url = isConsoleOnline
        ? 'https://bce.bdstatic.com/console/static/i18n/console.%s.json'
        : 'https://bce.bdstatic.com/console/static/i18n/console.offline.%s.json';

    i18n.init({url});

    try {
        await i18n.activate(language);
    } catch {
        /* empty */
    }
};
